<script>
	import OutboundLink from 'components/outbound-link.vue';

	export default {
		components: {
			'outbound-link': OutboundLink
		},
		props: {
			panels: {
				type: Array,
				required: true
			},
			headerText: {
				type: String
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.news-panel {
		padding: 3rem 0 1.5rem;

		h2 {
			text-align: center;
		}

		.news-feed {
			display: grid;
			grid-template-columns: 1fr;
			grid-auto-rows: 1fr;
			gap: 1rem;

			@include media(med) {
				grid-template-columns: repeat(4, 1fr);
				gap: 2rem;
			}

			@include media(lg) {
				gap: 3rem;
			}
		}

		.news-card {
			display: flex;
			overflow: hidden;

			@include media(med) {
				flex-direction: column;
			}
		}

		.image-container {
			flex-basis: 7.5rem;

			@include media(sm, max) {
				flex-basis: 5rem;
			}

			@include media(med) {
				height: 8.5rem;
				flex-basis: 8.5rem;
			}
		}

		.card-image {
			background-color: $c-babyblue;
			object-fit: cover;
			object-position: center center;
			width: 100%;
			height: 100%;
		}

		.card-info {
			flex: 1 0;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			padding: 2rem 1.5rem 1.25rem;

			@include media(lg, max) {
				padding: 1rem;
				font-size: 1rem;
			}
		}

		.article-name {
			margin: 0 0 1.5rem;
			font-weight: 500;
			line-height: 1.2;

			@include media(lg, max) {
				font-size: 1rem;
			}
		}

		.card-link {
			@include media(lg) {
				font-size: 1.125rem;
			}

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
<template>
	<section class="news-panel">
		<div class="wrapper">
			<h2>{{ headerText }}</h2>
			<ul class="news-feed list-unstyled">
				<li
					v-for="panel in panels"
					:key="panel.name"
					class="news-card panel-card">
					<div class="image-container">
						<img
							class="card-image"
							loading="lazy"
							:src="panel.image.url"
							:alt="panel.image.alt_text" />
					</div>
					<div class="card-info">
						<h3
							:id="`news-panel-heading-${panel.name}`"
							class="article-name">
							{{ panel.content_text }}
						</h3>
						<outbound-link
							:href="panel.actions[0].url"
							class="card-link"
							:data-outbound-link="panel.actions[0].tag || 'HOMEPAGE_NEWS_PANEL'"
							:aria-describedby="`news-panel-heading-${panel.name}`">
							Read More
							<i
								class="fa-solid fa-arrow-right"
								aria-hidden="true"></i>
						</outbound-link>
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>
